// Patient-side correction-request client. Identity fields on PatientInfo
// (name / dateOfBirth / gender / mobile / email) are clinic-owned, so the
// patient can't edit them directly through the portal — they file a
// request here and the support / clinic team applies the change after
// review.
//
// Backend: in.aumhum.aumhum.patient.controller.MeCorrectionRequestsController.

import { shouldUseMocks } from './mockApi'
import { patientGet, patientPost } from './patientApi'

const BASE = '/api/secure/me/correction-requests'
const NO_CONTEXT = { requirePatientContext: false }

function unwrap(res) {
  return res?.data
}

/**
 * Submit a new correction request. Body:
 *   { patientId, fieldName, requestedValue, reason }
 * fieldName ∈ name | dateOfBirth | gender | mobile | email | other.
 * For "other", reason is required and requestedValue is null.
 */
export async function submitCorrectionRequest(body) {
  if (shouldUseMocks()) return null
  const res = await patientPost(BASE, body, NO_CONTEXT)
  return unwrap(res)
}

/** GET — list the caller's own correction requests. Optional status filter. */
export async function listMyCorrectionRequests(params = {}) {
  if (shouldUseMocks()) return []
  const res = await patientGet(BASE, { ...NO_CONTEXT, params })
  return unwrap(res) || []
}

/** POST /:id/cancel — cancel a pending request. */
export async function cancelCorrectionRequest(requestId) {
  if (shouldUseMocks()) return null
  const res = await patientPost(
    `${BASE}/${encodeURIComponent(requestId)}/cancel`,
    null,
    NO_CONTEXT,
  )
  return unwrap(res)
}
